// import { useEffect, useMemo, useState } from "react";
// import { Link } from "react-router-dom";
// import dayjs from "dayjs";
// import { listReports } from "../../api";
// import "./ReportsList.css";

// // TODO: replace with real auth
// const currentUserId = 7;

// const PAGE_SIZES = [10, 20, 50];

// export default function ReportsList() {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [err, setErr] = useState(null);

//   const [query, setQuery] = useState("");
//   const [status, setStatus] = useState("ALL");
//   const [sortBy, setSortBy] = useState("created_at_desc");
//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);

//   useEffect(() => {
//     fetchReports();
//   }, []);

//   const fetchReports = async () => {
//     try {
//       setErr(null);
//       setLoading(true);

//       const { data } = await listReports({
//         mine: 1,
//         user_id: currentUserId,
//       });

//       setRows(Array.isArray(data) ? data : []);
//     } catch (error) {
//       setErr(error?.response?.data?.error || error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const statusOptions = useMemo(() => {
//     const statuses = new Set(rows.map((row) => row.status_code).filter(Boolean));
//     return ["ALL", ...Array.from(statuses)];
//   }, [rows]);

//   const filtered = useMemo(() => {
//     let data = [...rows];

//     if (status !== "ALL") {
//       data = data.filter((row) => row.status_code === status);
//     }

//     if (query.trim()) {
//       const q = query.trim().toLowerCase();

//       data = data.filter((row) => {
//         return (
//           (row.title || "").toLowerCase().includes(q) ||
//           (row.requester_name || "").toLowerCase().includes(q) ||
//           String(row.amount || "").includes(q)
//         );
//       });
//     }

//     switch (sortBy) {
//       case "amount_desc":
//         data.sort((a, b) => Number(b.amount || 0) - Number(a.amount || 0));
//         break;

//       case "amount_asc":
//         data.sort((a, b) => Number(a.amount || 0) - Number(b.amount || 0));
//         break;

//       case "status_asc":
//         data.sort((a, b) =>
//           String(a.status_code || "").localeCompare(String(b.status_code || ""))
//         );
//         break;

//       case "created_at_asc":
//         data.sort(
//           (a, b) => new Date(a.created_at || 0) - new Date(b.created_at || 0)
//         );
//         break;

//       case "created_at_desc":
//       default:
//         data.sort(
//           (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0)
//         );
//         break;
//     }

//     return data;
//   }, [rows, status, query, sortBy]);

//   const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
//   const pageClamped = Math.min(Math.max(page, 1), totalPages);

//   const pageData = useMemo(() => {
//     return filtered.slice(
//       (pageClamped - 1) * pageSize,
//       pageClamped * pageSize
//     );
//   }, [filtered, pageClamped, pageSize]);

//   const totalAmount = useMemo(() => {
//     return filtered.reduce((sum, row) => sum + Number(row.amount || 0), 0);
//   }, [filtered]);

//   const paidAmount = useMemo(() => {
//     return rows
//       .filter((row) => row.status_code === "PAID")
//       .reduce((sum, row) => sum + Number(row.amount || 0), 0);
//   }, [rows]);

//   const pendingCount = useMemo(() => {
//     return rows.filter((row) =>
//       [
//         "DRAFT",
//         "REQUEST_CHANGES",
//         "SUBMITTED",
//         "UNDER_MANAGER_REVIEW",
//         "UNDER_FINANCE_REVIEW",
//       ].includes(row.status_code)
//     ).length;
//   }, [rows]);

//   const resetFilters = () => {
//     setQuery("");
//     setStatus("ALL");
//     setSortBy("created_at_desc");
//     setPage(1);
//     setPageSize(PAGE_SIZES[0]);
//   };

//   const statusLabel = (value) => {
//     return String(value || "-").replaceAll("_", " ");
//   };

//   // Presentational-only helper: maps a report's lifecycle status to one of
//   // the shared chip tones (see ReportsList.css) so the Status column reads
//   // at a glance. Does not affect filtering/sorting logic above.
//   const statusToneClass = (value) => {
//     const tones = {
//       DRAFT: "acct-reportslist-status-neutral",
//       SUBMITTED: "acct-reportslist-status-info",
//       UNDER_MANAGER_REVIEW: "acct-reportslist-status-pending",
//       REQUEST_CHANGES: "acct-reportslist-status-danger",
//       MANAGER_APPROVED: "acct-reportslist-status-success",
//       UNDER_FINANCE_REVIEW: "acct-reportslist-status-pending",
//       APPROVED_FOR_PAYMENT: "acct-reportslist-status-success",
//       PAID: "acct-reportslist-status-success",
//     };

//     return tones[value] || "acct-reportslist-status-neutral";
//   };

//   const exportCSV = () => {
//     if (!filtered.length) {
//       alert("No reports available to export");
//       return;
//     }

//     const headers = ["ID", "Title", "Status", "Amount", "Requester", "Created"];

//     const rowsCsv = filtered.map((row) => [
//       row.id,
//       row.title || "",
//       row.status_code || "-",
//       Number(row.amount || 0).toFixed(2),
//       row.requester_name || "-",
//       row.created_at ? dayjs(row.created_at).format("YYYY-MM-DD HH:mm") : "-",
//     ]);

//     const csv =
//       [headers, ...rowsCsv]
//         .map((cols) =>
//           cols
//             .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
//             .join(",")
//         )
//         .join("\n");

//     const blob = new Blob([csv], {
//       type: "text/csv;charset=utf-8",
//     });

//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");

//     link.href = url;
//     link.download = "my-expense-reports.csv";
//     link.click();

//     URL.revokeObjectURL(url);
//   };

//   return (
//     <div className="unit-page acct-reportslist-theme">
//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Accounts</div>
//           <h2>My Expense Reports</h2>
//           <p>View, filter, sort and manage your submitted expense reports.</p>
//         </div>

//         <div className="unit-header-actions">
//           <button className="unit-btn unit-btn-light" onClick={fetchReports}>
//             Refresh
//           </button>

//           <button className="unit-btn unit-btn-light" onClick={exportCSV}>
//             Export CSV
//           </button>

//           <Link
//             to="/admin/accounts/reports/new"
//             className="unit-btn unit-btn-primary text-decoration-none"
//           >
//             + New Report
//           </Link>
//         </div>
//       </div>

//       {err && (
//         <div className="alert alert-danger mb-3">
//           {err}
//         </div>
//       )}

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <span>Total Reports</span>
//           <strong>{rows.length}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Filtered Reports</span>
//           <strong>{filtered.length}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Pending</span>
//           <strong>{pendingCount}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Total Amount</span>
//           <strong>₹{totalAmount.toFixed(2)}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Paid Amount</span>
//           <strong>₹{paidAmount.toFixed(2)}</strong>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>Expense Report List</h5>
//             <p>Search by title, requester, amount, status or created date.</p>
//           </div>

//           <div className="unit-toolbar-actions">
//             <div className="input-group unit-search">
//               <span className="input-group-text">⌕</span>

//               <input
//                 className="form-control"
//                 placeholder="Search title, requester, or amount..."
//                 value={query}
//                 onChange={(e) => {
//                   setQuery(e.target.value);
//                   setPage(1);
//                 }}
//               />

//               {query && (
//                 <button
//                   className="unit-clear-btn"
//                   type="button"
//                   onClick={() => {
//                     setQuery("");
//                     setPage(1);
//                   }}
//                 >
//                   Clear
//                 </button>
//               )}
//             </div>

//             <select
//               className="form-select unit-page-size"
//               value={status}
//               onChange={(e) => {
//                 setStatus(e.target.value);
//                 setPage(1);
//               }}
//             >
//               {statusOptions.map((item) => (
//                 <option key={item} value={item}>
//                   {statusLabel(item)}
//                 </option>
//               ))}
//             </select>

//             <select
//               className="form-select unit-page-size"
//               value={sortBy}
//               onChange={(e) => setSortBy(e.target.value)}
//             >
//               <option value="created_at_desc">Newest</option>
//               <option value="created_at_asc">Oldest</option>
//               <option value="amount_desc">Amount High</option>
//               <option value="amount_asc">Amount Low</option>
//               <option value="status_asc">Status A-Z</option>
//             </select>

//             <select
//               className="form-select unit-page-size"
//               value={pageSize}
//               onChange={(e) => {
//                 setPageSize(Number(e.target.value));
//                 setPage(1);
//               }}
//             >
//               {PAGE_SIZES.map((size) => (
//                 <option key={size} value={size}>
//                   {size} rows
//                 </option>
//               ))}
//             </select>

//             {(query || status !== "ALL" || sortBy !== "created_at_desc") && (
//               <button className="unit-btn unit-btn-light" onClick={resetFilters}>
//                 Reset
//               </button>
//             )}
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <div className="spinner-border" role="status"></div>
//               <p>Loading expense reports...</p>
//             </div>
//           ) : (
//             <table className="table unit-table">
//               <thead>
//                 <tr>
//                   <th style={{ width: "80px" }}>ID</th>
//                   <th>Report</th>
//                   <th>Status</th>
//                   <th>Amount</th>
//                   <th>Created</th>
//                   <th className="text-end" style={{ width: "120px" }}>
//                     Action
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {pageData.length > 0 ? (
//                   pageData.map((report) => (
//                     <tr key={report.id}>
//                       <td>
//                         <span className="unit-id">#{report.id}</span>
//                       </td>

//                       <td>
//                         <div className="unit-name-box">
//                           <div className="unit-letter">
//                             {report.title?.charAt(0)?.toUpperCase() || "R"}
//                           </div>

//                           <div>
//                             <strong>{report.title || "-"}</strong>
//                             <small>
//                               by {report.requester_name || "—"}
//                             </small>
//                           </div>
//                         </div>
//                       </td>

//                       <td>
//                         <span
//                           className={`unit-status ${statusToneClass(
//                             report.status_code
//                           )}`}
//                         >
//                           {statusLabel(report.status_code)}
//                         </span>
//                       </td>

//                       <td>
//                         <span className="unit-id">
//                           ₹{Number(report.amount || 0).toFixed(2)}
//                         </span>
//                       </td>

//                       <td>
//                         {report.created_at
//                           ? dayjs(report.created_at).format("DD MMM, HH:mm")
//                           : "-"}
//                       </td>

//                       <td>
//                         <div className="unit-actions">
//                           <Link
//                             className="unit-btn unit-btn-light text-decoration-none"
//                             to={`/admin/accounts/reports/${report.id}`}
//                           >
//                             Open
//                           </Link>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="6">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">□</div>
//                         <h5>No reports found</h5>
//                         <p>Try another keyword or create a new expense report.</p>

//                         <Link
//                           to="/admin/accounts/reports/new"
//                           className="unit-btn unit-btn-primary text-decoration-none"
//                         >
//                           + Create Report
//                         </Link>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing{" "}
//             <strong>
//               {filtered.length === 0 ? 0 : (pageClamped - 1) * pageSize + 1}
//             </strong>{" "}
//             to{" "}
//             <strong>{Math.min(pageClamped * pageSize, filtered.length)}</strong>{" "}
//             of <strong>{filtered.length}</strong> entries
//           </div>

//           {totalPages > 1 && (
//             <ul className="pagination unit-pagination">
//               <li className={`page-item ${pageClamped <= 1 ? "disabled" : ""}`}>
//                 <button
//                   className="page-link"
//                   disabled={pageClamped <= 1}
//                   onClick={() => setPage((prev) => Math.max(1, prev - 1))}
//                 >
//                   Prev
//                 </button>
//               </li>

//               {[...Array(totalPages)].map((_, index) => (
//                 <li
//                   key={index + 1}
//                   className={`page-item ${
//                     pageClamped === index + 1 ? "active" : ""
//                   }`}
//                 >
//                   <button
//                     className="page-link"
//                     onClick={() => setPage(index + 1)}
//                   >
//                     {index + 1}
//                   </button>
//                 </li>
//               ))}

//               <li
//                 className={`page-item ${
//                   pageClamped >= totalPages ? "disabled" : ""
//                 }`}
//               >
//                 <button
//                   className="page-link"
//                   disabled={pageClamped >= totalPages}
//                   onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))}
//                 >
//                   Next
//                 </button>
//               </li>
//             </ul>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }



import { useEffect, useMemo, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { listReports } from "../../api";
import "./ReportsList.css";

// TODO: replace with real auth
const currentUserId = 7;

const PAGE_SIZES = [10, 20, 50];

export default function ReportsList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("ALL");
  const [sortBy, setSortBy] = useState("created_at_desc");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      setErr(null);
      setLoading(true);

      const { data } = await listReports({
        mine: 1,
        user_id: currentUserId,
      });

      setRows(Array.isArray(data) ? data : []);
    } catch (error) {
      setErr(error?.response?.data?.error || error.message);
    } finally {
      setLoading(false);
    }
  };

  const statusOptions = useMemo(() => {
    const statuses = new Set(
      rows.map((row) => row.status_code).filter(Boolean)
    );

    return ["ALL", ...Array.from(statuses)];
  }, [rows]);

  const filtered = useMemo(() => {
    let data = [...rows];

    if (status !== "ALL") {
      data = data.filter((row) => row.status_code === status);
    }

    if (query.trim()) {
      const q = query.trim().toLowerCase();

      data = data.filter((row) => {
        return (
          (row.title || "").toLowerCase().includes(q) ||
          (row.requester_name || "").toLowerCase().includes(q) ||
          String(row.amount || "").includes(q) ||
          String(row.status_code || "").toLowerCase().includes(q) ||
          (row.created_at
            ? dayjs(row.created_at).format("DD MMM YYYY HH:mm").toLowerCase()
            : ""
          ).includes(q)
        );
      });
    }

    switch (sortBy) {
      case "amount_desc":
        data.sort(
          (a, b) => Number(b.amount || 0) - Number(a.amount || 0)
        );
        break;

      case "amount_asc":
        data.sort(
          (a, b) => Number(a.amount || 0) - Number(b.amount || 0)
        );
        break;

      case "status_asc":
        data.sort((a, b) =>
          String(a.status_code || "").localeCompare(
            String(b.status_code || "")
          )
        );
        break;

      case "created_at_asc":
        data.sort(
          (a, b) =>
            new Date(a.created_at || 0) - new Date(b.created_at || 0)
        );
        break;

      case "created_at_desc":
      default:
        data.sort(
          (a, b) =>
            new Date(b.created_at || 0) - new Date(a.created_at || 0)
        );
        break;
    }

    return data;
  }, [rows, status, query, sortBy]);

  const totalPages = Math.max(
    1,
    Math.ceil(filtered.length / pageSize)
  );

  const pageClamped = Math.min(
    Math.max(page, 1),
    totalPages
  );

  const pageData = useMemo(() => {
    return filtered.slice(
      (pageClamped - 1) * pageSize,
      pageClamped * pageSize
    );
  }, [filtered, pageClamped, pageSize]);

  const totalAmount = useMemo(() => {
    return filtered.reduce(
      (sum, row) => sum + Number(row.amount || 0),
      0
    );
  }, [filtered]);

  const paidAmount = useMemo(() => {
    return rows
      .filter((row) => row.status_code === "PAID")
      .reduce(
        (sum, row) => sum + Number(row.amount || 0),
        0
      );
  }, [rows]);

  const pendingCount = useMemo(() => {
    return rows.filter((row) =>
      [
        "DRAFT",
        "REQUEST_CHANGES",
        "SUBMITTED",
        "UNDER_MANAGER_REVIEW",
        "UNDER_FINANCE_REVIEW",
      ].includes(row.status_code)
    ).length;
  }, [rows]);

  const resetFilters = () => {
    setQuery("");
    setStatus("ALL");
    setSortBy("created_at_desc");
    setPage(1);
    setPageSize(PAGE_SIZES[0]);
  };

  const statusLabel = (value) => {
    return String(value || "-").replaceAll("_", " ");
  };

  const statusToneClass = (value) => {
    const tones = {
      DRAFT: "acct-reportslist-status-neutral",
      SUBMITTED: "acct-reportslist-status-info",
      UNDER_MANAGER_REVIEW: "acct-reportslist-status-pending",
      REQUEST_CHANGES: "acct-reportslist-status-danger",
      MANAGER_APPROVED: "acct-reportslist-status-success",
      UNDER_FINANCE_REVIEW: "acct-reportslist-status-pending",
      APPROVED_FOR_PAYMENT: "acct-reportslist-status-success",
      PAID: "acct-reportslist-status-success",
    };

    return (
      tones[value] ||
      "acct-reportslist-status-neutral"
    );
  };

  const exportCSV = () => {
    if (!filtered.length) {
      alert("No reports available to export");
      return;
    }

    const headers = [
      "ID",
      "Title",
      "Status",
      "Amount",
      "Requester",
      "Created",
    ];

    const rowsCsv = filtered.map((row) => [
      row.id,
      row.title || "",
      row.status_code || "-",
      Number(row.amount || 0).toFixed(2),
      row.requester_name || "-",
      row.created_at
        ? dayjs(row.created_at).format(
            "YYYY-MM-DD HH:mm"
          )
        : "-",
    ]);

    const csv = [headers, ...rowsCsv]
      .map((cols) =>
        cols
          .map(
            (value) =>
              `"${String(value || "").replace(
                /"/g,
                '""'
              )}"`
          )
          .join(",")
      )
      .join("\n");

    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "my-expense-reports.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  const summaryCards = [
    {
      label: "Total Reports",
      value: rows.length,
      icon: "fa-solid fa-file-invoice",
      className: "acct-stat-blue",
    },
    {
      label: "Filtered Reports",
      value: filtered.length,
      icon: "fa-solid fa-filter",
      className: "acct-stat-purple",
    },
    {
      label: "Pending",
      value: pendingCount,
      icon: "fa-solid fa-clock",
      className: "acct-stat-orange",
    },
    {
      label: "Total Amount",
      value: `₹${totalAmount.toFixed(2)}`,
      icon: "fa-solid fa-indian-rupee-sign",
      className: "acct-stat-cyan",
    },
    {
      label: "Paid Amount",
      value: `₹${paidAmount.toFixed(2)}`,
      icon: "fa-solid fa-circle-check",
      className: "acct-stat-green",
    },
  ];

  return (
    <div className="unit-page acct-reportslist-theme">
      {/* Top heading box */}
      <div className="acct-reportslist-heading-box">
        <div className="acct-reportslist-heading-content">
          <div className="acct-reportslist-heading-icon">
            <i className="fa-solid fa-receipt"></i>
          </div>

          <div>
            <div className="unit-page-label">
              Accounts
            </div>

            <h2>My Expense Reports</h2>

            <p>
              View, filter, sort and manage your
              submitted expense reports.
            </p>
          </div>
        </div>

        <div className="unit-header-actions">
          <button
            type="button"
            className="unit-btn unit-btn-light"
            onClick={fetchReports}
            disabled={loading}
          >
            <i
              className={`fa-solid fa-arrows-rotate ${
                loading ? "fa-spin" : ""
              }`}
            ></i>
            Refresh
          </button>

          <button
            type="button"
            className="unit-btn unit-btn-light"
            onClick={exportCSV}
          >
            <i className="fa-solid fa-file-csv"></i>
            Export CSV
          </button>

          <Link
            to="/admin/accounts/reports/new"
            className="unit-btn unit-btn-primary text-decoration-none"
          >
            <i className="fa-solid fa-plus"></i>
            New Report
          </Link>
        </div>
      </div>

      {err && (
        <div className="alert alert-danger mb-3 acct-reportslist-alert">
          <i className="fa-solid fa-circle-exclamation"></i>
          <span>{err}</span>
        </div>
      )}

      {/* Stats cards */}
      <div className="unit-stats-row">
        {summaryCards.map((item) => (
          <div
            className={`unit-stat-card ${item.className}`}
            key={item.label}
          >
            <div className="acct-stat-card-content">
              <div className="acct-stat-card-copy">
                <span>{item.label}</span>
                <strong>{item.value}</strong>
              </div>

              <div className="acct-stat-icon">
                <i className={item.icon}></i>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Main table card */}
      <div className="unit-card">
        <div className="unit-toolbar">
          <div className="acct-reportslist-section-title">
            <div className="acct-reportslist-section-icon">
              <i className="fa-solid fa-table-list"></i>
            </div>

            <div>
              <h5>Expense Report List</h5>

              <p>
                Search by title, requester, amount,
                status or created date.
              </p>
            </div>
          </div>

          <div className="unit-toolbar-actions">
            <div className="input-group unit-search">
              <span className="input-group-text">
                <i className="fa-solid fa-magnifying-glass"></i>
              </span>

              <input
                className="form-control"
                placeholder="Search title, requester, or amount..."
                value={query}
                onChange={(e) => {
                  setQuery(e.target.value);
                  setPage(1);
                }}
              />

              {query && (
                <button
                  className="unit-clear-btn"
                  type="button"
                  onClick={() => {
                    setQuery("");
                    setPage(1);
                  }}
                  title="Clear search"
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              )}
            </div>

            <select
              className="form-select unit-page-size"
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
                setPage(1);
              }}
              title="Filter by status"
            >
              {statusOptions.map((item) => (
                <option
                  key={item}
                  value={item}
                >
                  {item === "ALL"
                    ? "All Status"
                    : statusLabel(item)}
                </option>
              ))}
            </select>

            <select
              className="form-select unit-page-size"
              value={sortBy}
              onChange={(e) =>
                setSortBy(e.target.value)
              }
              title="Sort reports"
            >
              <option value="created_at_desc">
                Newest
              </option>
              <option value="created_at_asc">
                Oldest
              </option>
              <option value="amount_desc">
                Amount High
              </option>
              <option value="amount_asc">
                Amount Low
              </option>
              <option value="status_asc">
                Status A-Z
              </option>
            </select>

            <select
              className="form-select unit-page-size"
              value={pageSize}
              onChange={(e) => {
                setPageSize(
                  Number(e.target.value)
                );
                setPage(1);
              }}
              title="Rows per page"
            >
              {PAGE_SIZES.map((size) => (
                <option
                  key={size}
                  value={size}
                >
                  {size} rows
                </option>
              ))}
            </select>

            {(query ||
              status !== "ALL" ||
              sortBy !== "created_at_desc" ||
              pageSize !== PAGE_SIZES[0]) && (
              <button
                type="button"
                className="unit-btn unit-btn-light"
                onClick={resetFilters}
              >
                <i className="fa-solid fa-rotate-left"></i>
                Reset
              </button>
            )}
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <div
                className="spinner-border"
                role="status"
              ></div>
              <p>Loading expense reports...</p>
            </div>
          ) : (
            <table className="table unit-table">
              <thead>
                <tr>
                  <th style={{ width: "80px" }}>
                    ID
                  </th>
                  <th>Report</th>
                  <th>Status</th>
                  <th>Amount</th>
                  <th>Created</th>
                  <th
                    className="text-end"
                    style={{ width: "120px" }}
                  >
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {pageData.length > 0 ? (
                  pageData.map((report) => (
                    <tr key={report.id}>
                      <td>
                        <span className="unit-id">
                          #{report.id}
                        </span>
                      </td>

                      <td>
                        <div className="unit-name-box">
                          <div className="unit-letter">
                            {report.title
                              ?.charAt(0)
                              ?.toUpperCase() ||
                              "R"}
                          </div>

                          <div className="unit-name-copy">
                            <strong>
                              {report.title ||
                                "-"}
                            </strong>

                            <small>
                              <i className="fa-regular fa-user"></i>
                              by{" "}
                              {report.requester_name ||
                                "—"}
                            </small>
                          </div>
                        </div>
                      </td>

                      <td>
                        <span
                          className={`unit-status ${statusToneClass(
                            report.status_code
                          )}`}
                        >
                          {statusLabel(
                            report.status_code
                          )}
                        </span>
                      </td>

                      <td>
                        <span className="unit-amount">
                          ₹
                          {Number(
                            report.amount || 0
                          ).toFixed(2)}
                        </span>
                      </td>

                      <td>
                        <span className="unit-date">
                          <i className="fa-regular fa-calendar"></i>

                          {report.created_at
                            ? dayjs(
                                report.created_at
                              ).format(
                                "DD MMM, HH:mm"
                              )
                            : "-"}
                        </span>
                      </td>

                      <td>
                        <div className="unit-actions">
                          <Link
                            className="unit-btn unit-btn-light unit-open-btn text-decoration-none"
                            to={`/admin/accounts/reports/${report.id}`}
                          >
                            <i className="fa-solid fa-arrow-up-right-from-square"></i>
                            Open
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-regular fa-folder-open"></i>
                        </div>

                        <h5>
                          No reports found
                        </h5>

                        <p>
                          Try another keyword or
                          create a new expense
                          report.
                        </p>

                        <Link
                          to="/admin/accounts/reports/new"
                          className="unit-btn unit-btn-primary text-decoration-none"
                        >
                          <i className="fa-solid fa-plus"></i>
                          Create Report
                        </Link>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing{" "}
            <strong>
              {filtered.length === 0
                ? 0
                : (pageClamped - 1) *
                    pageSize +
                  1}
            </strong>{" "}
            to{" "}
            <strong>
              {Math.min(
                pageClamped * pageSize,
                filtered.length
              )}
            </strong>{" "}
            of{" "}
            <strong>
              {filtered.length}
            </strong>{" "}
            entries
          </div>

          {totalPages > 1 && (
            <ul className="pagination unit-pagination">
              <li
                className={`page-item ${
                  pageClamped <= 1
                    ? "disabled"
                    : ""
                }`}
              >
                <button
                  className="page-link"
                  disabled={pageClamped <= 1}
                  onClick={() =>
                    setPage((prev) =>
                      Math.max(1, prev - 1)
                    )
                  }
                >
                  <i className="fa-solid fa-chevron-left"></i>
                  Prev
                </button>
              </li>

              {compactPageItems([...Array(totalPages)].map(
                (_, index) => (
                  <li
                    key={index + 1}
                    className={`page-item ${
                      pageClamped ===
                      index + 1
                        ? "active"
                        : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        setPage(index + 1)
                      }
                    >
                      {index + 1}
                    </button>
                  </li>
                )
              ), pageClamped)}

              <li
                className={`page-item ${
                  pageClamped >= totalPages
                    ? "disabled"
                    : ""
                }`}
              >
                <button
                  className="page-link"
                  disabled={
                    pageClamped >= totalPages
                  }
                  onClick={() =>
                    setPage((prev) =>
                      Math.min(
                        totalPages,
                        prev + 1
                      )
                    )
                  }
                >
                  Next
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}